import { TimelogState } from '../models';

/**
 * Liefert die Zustands-Bezeichnungen in der aktuell geladenen Sprache.
 * Die $localize-Auswertung erfolgt bei jedem Aufruf zur Laufzeit, nachdem loadTranslations
 * gelaufen ist. Sie darf nicht auf Modulebene passieren: der Helper wird schon beim Start über
 * die Wurzel-Komponente geladen, sodass der Quelltext sonst beim Import einfrieren würde, bevor
 * die Übersetzungen bereitstehen.
 */
export function getStateConfig(): { [index: string]: string } {
  return {
    [TimelogState.Unkown]: $localize`Unbekannt`,
    [TimelogState.Previous]: $localize`Vorherig`,
    [TimelogState.DayStarting]: $localize`Tagesstart`,
    [TimelogState.Working]: $localize`Arbeitszeit`,
    [TimelogState.DayEnding]: $localize`Tagesende`,
    [TimelogState.Individual]: $localize`Individuell`,
    [TimelogState.CarEquiping]: $localize`Fahrzeug rüsten`,
    [TimelogState.CarDriving]: $localize`Fahrzeit`,
    [TimelogState.CustomerWorking]: $localize`Kundenzeit`,
    [TimelogState.MachineWorking]: $localize`Automatenzeit`,
    [TimelogState.BufferstockEquiping]: $localize`Bufferstock rüsten`,
  };
}
